import { useGetProfile, useUpdateLanguage } from '@/features/space-user';
import { useLanguageOptions } from '@/legacy/i18n';

export const useTopBarLanguage = () => {
	const { data: profile, isLoading, isError } = useGetProfile();
	const { updateLanguage, isSaving } = useUpdateLanguage();
	const languageOptions = useLanguageOptions();

	return {
		profile,
		isLoading,
		isError,
		isPendingSaveProfile: isSaving,
		onSubmit: updateLanguage,
		languageOptions,
	};
};
